import React, { useEffect, useState, useCallback } from "react";
import { useForm, FormProvider } from "react-hook-form";
//Material
import { Button } from "@material-ui/core";
import Divider from "@material-ui/core/Divider";
import Paper from "@material-ui/core/Paper";
import InputBase from "@material-ui/core/InputBase";
//Component
import { ReactTable } from "../../stories/react-table";
import { BaseContainer } from "../../stories/base-container";
import { BoxTemplate1 } from "../../stories/Box";
import { makeStyles } from "@material-ui/core/styles";
//Function
import { url, method } from "./signalr";
import { useSignalR } from "./../function-api/useSignalR";
import { getUserDataManagementColumns } from "./columns/user-data-management";
import { GetUser } from "../../utils/sessions";
import { useSelectRowOpenModal } from "../function-api/useSelectRowOpenModal";
import UserDataDownloadTemplateModal from "./modal/user-data-download-template";
import UserDataImportHistoryModal from "./modal/user-data-import-history";
import UserDataImportModal from "./modal/user-data-import";
import * as api from "./api";

const useStyles = makeStyles((theme) => ({
  rootSearch: {
    padding: "2px 4px",
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    width: 400,
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButtonX: {
    padding: 10,
  },
  iconButton: {
    backgroundColor: "#000",
    color: "#fff",
  },
  iconButtonAddDelete: {
    backgroundColor: "#000",
    color: "#fff",
    marginRight: theme.spacing(2),
  },
  divider: {
    height: 28,
    margin: 4,
  },
}));

const rowStyle = (row, rowIndex) => {
  return { backgroundColor: row.STATUS_COLOR };
};

function UserDataManagement() {
  //State
  const methodForm = useForm();
  const { register, getValues } = methodForm;

  const {
    isOpen: openUploadModal,
    onClose: onCloseViewUpload,
    Data: selectedTemplate,
    handleClickRow: onClickRow,
  } = useSelectRowOpenModal();

  const [DataList, setDataList] = useState([]);
  const [historyList, setHistoryList] = useState([]);

  const [openDownloadModal, setOpenDowloadModal] = useState(false);
  const [openHistoryModal, setOpenHistoryModal] = useState(false);

  const classes = useStyles();
  const fetch = useCallback(async () => {
    setDataList([]);
    const param = {
      TEXT_SEARCH: getValues()?.TEXT_SEARCH,
      USER_ID: GetUser(),
      MODE: "Refresh",
    };
    const res = await api.GetListUserDataManagement(param);
    setDataList(res);
  }, [getValues]);

  const signalRHandler = useCallback(
    async (data) => {
      await fetch();
    },
    [fetch]
  );

  useSignalR(url, method, signalRHandler);

  //Effect
  useEffect(() => {
    fetch();
  }, [fetch]);

  const onOpenDownloadTemplate = () => {
    setOpenDowloadModal(true);
  };

  const onCloseViewDowload = () => {
    setOpenDowloadModal(false);
  };

  const onViewHistory = (TEMPLATE_ID) => {
    const fetchHistory = async () => {
      let param = { TEMPLATE_ID: TEMPLATE_ID };
      let res = await api.GetListViewUploadDataHistory(param);
      setHistoryList(res);
    };
    fetchHistory();
    setOpenHistoryModal(true);
  };

  const onCloseViewHistory = () => {
    setOpenHistoryModal(false);
  };

  const onUploadTemplate = async (row) => {
    let param = { TEMPLATE_ID: row.TEMPLATE_ID };
    let res = await api.GetLatestUploadUserData(param);
    onClickRow(res);
  };

  const onHandleEnter = (e) => {
    if (e.keyCode === 13) {
      onSearchText();
      e.preventDefault();
    }
  };

  const onSearchText = async () => {
    fetch();
  };

  const tablecomponent = () => {
    return (
      <>
        <Button
          className={classes.iconButtonAddDelete}
          variant="contained"
          onClick={() => {
            onOpenDownloadTemplate();
          }}
        >
          Download Template
        </Button>
      </>
    );
  };

  const searchcomponent = (searchProps) => {
    return (
      <>
        <Paper component="form" className={classes.rootSearch}>
          <InputBase
            className={classes.input}
            placeholder="Search"
            inputProps={{ "aria-label": "search" }}
            name="TEXT_SEARCH"
            inputRef={register}
            onKeyDown={(e) => onHandleEnter(e)}
          />
          <Divider className={classes.divider} orientation="vertical" />
          <Button
            variant="contained"
            className={classes.iconButton}
            onClick={onSearchText}
          >
            Search
          </Button>
        </Paper>
      </>
    );
  };

  return (
    <div>
      <BaseContainer maxWidth={false}>
        <BoxTemplate1 height="80vh" title="User Data Management">
          <FormProvider {...methodForm}>
            <ReactTable
              keyField="TEMPLATE_ID"
              data={DataList}
              columns={getUserDataManagementColumns(
                onUploadTemplate,
                onViewHistory
              )}
              headcomponent={tablecomponent}
              showSearch={false}
              headRightcomponent={searchcomponent}
              rowStyle={rowStyle}
            />
          </FormProvider>
        </BoxTemplate1>
        <UserDataImportHistoryModal
          open={openHistoryModal}
          onClose={onCloseViewHistory}
          datalist={historyList}
        />
        <UserDataDownloadTemplateModal
          open={openDownloadModal}
          onClose={onCloseViewDowload}
        />
        <UserDataImportModal
          open={openUploadModal}
          onClose={onCloseViewUpload}
          data={selectedTemplate}
          fetchmain={fetch}
        />
      </BaseContainer>
    </div>
  );
}
export default UserDataManagement;
